// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index.js'
/* 路由 */
import router from './router'
import 'lib-flexible/flexible.js' //rem
import 'view-design/dist/styles/iview.css'

import { 
    Select, 
    Option, 
    Page, 
    Input, 
    Button, 
    Spin, 
    Icon, 
    Radio, 
    Message, 
    Modal,
    Form,
    FormItem
} from 'view-design';
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Page', Page);
Vue.component('Input', Input);
Vue.component('Button', Button);
Vue.component('Radio ', Radio);
Vue.component('Spin', Spin);
Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.prototype.$Message = Message;

/* axios */
import axios from './api'
import api from './api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'


import LyTab from '../packages/tab'
Vue.use(LyTab)

/* animate.css */
import 'animate.css'

// 图片预览，在img或父级标签上直接添加v-viewer，然后就可以对包含的所有img进行预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' },
    url: "data-source",// 大图地址参数
    filter (image) {
        // 只有大图的才能放大
        let dataSource = image.getAttribute('data-source')
        if (dataSource == null || dataSource == undefined) {
            return false;
        } else {
            return true;
        }
    }
});

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 尾部组件 */
import FooterSearchthird from './components/FooterSearchthird'
Vue.component(FooterSearchthird.name, FooterSearchthird)


/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

import i18n from "./i18n/index.js"

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
});

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    beforeCreate () { Vue.prototype.$bus = this },
    i18n
})

// 屏蔽鼠标右键
document.oncontextmenu = function () {
    return false;
}
// 加入百度统计
router.beforeEach((to, from, next) => {
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next()
})





// WEBPACK FOOTER //
// ./src/main.js